import { render, staticRenderFns } from "./ConfirmEndDraftModal.vue?vue&type=template&id=4e8a135b&scoped=true&"
import script from "./ConfirmEndDraftModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmEndDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEndDraftModal.vue?vue&type=style&index=0&id=4e8a135b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a135b",
  null
  
)

export default component.exports